
/*
 * Loads in the quiz post navigation.
 */

(function ($) {
    var $document = $(document),
        $window = $(window);

    $.fn.mechanism_filters = function () {

        return this.each(function () {

            var container = $(this),
                content = $(container.data('selector')),
                search = container.find('.filter-search'),
                search_clear = container.find('.filter-search-clear'),
                selected = {};

            container.on("click", ".opt a", function (e) {
                e.preventDefault();
                var opt = $(this),
                    filter = opt.closest('.filter'),
                    title = filter.find('.title .value'),
                    group = filter.find('.options').data('group'),
                    label = opt.text(),
                    value = opt.data('value');

                if (value !== "") {
                    title.empty().toggleClass('set', true).append(label);
                    selected[group] = value;
                } else {
                    title.empty().toggleClass('set', false);
                    delete selected[group];
                }
                search.val('');
                filter_content();
            });

            search.closest('form').submit(function(e){ e.preventDefault(); });
            search.keyup(function (e) {
                var code = (e.keyCode || e.which),
                term = search.val().replace(/\s+/g, '-').toLowerCase();
                if($.inArray(code, [37,38,39,40,9,13,16,17] ) > -1) {
                    return;
                }
                search_clear.toggleClass('display',true);
                filter_content(term);
            });

            search_clear.on('click',function (e){
                e.preventDefault();
                search.val('');
                filter_content();
                $(this).toggleClass('display',false);
            });

            var filter_content = function (term='') {
                var requiredClasses = Object.values(selected),
                    classSelector = '.' + requiredClasses.join('.');

                if (classSelector === '.') {
                    content.toggleClass('active', false).toggleClass('filtered', false);
                } else {
                    content.toggleClass('active', false).toggleClass('filtered', true).filter(classSelector).toggleClass('filtered', false);
                }

                if(term !== ''){
                    var keywords = content.not('.filtered').find("a:not([data-id^='#"+term+"'])");
                    keywords.closest('li').toggleClass('filtered', true);
                }

                $('.results .country.active').toggleClass('active', false);

            }

        });

    };

    $document.ready(function () {
        $('#mechanism-results .filters').mechanism_filters();
    });


})(jQuery);

